import React, { useState, useEffect, useCallback } from "react";
import "../../Styles/yellowcalf.css/Wallet_Sales_Report_Based.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";
import { formatNumber } from "../../utils/formatNumber";

function Wallet_Sales_Report_Based() {
  // 1. States for Data and Filters
  const [salesData, setSalesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    studentId: "",
    startDate: "2024-01-27",
    endDate: "2026-02-02",
  });

  // 2. API Fetch Function
  const fetchInitialData = useCallback(async () => {
    setLoading(true);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key:
          localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
        language: "en",
        user_id: localStorage.getItem("user_id") || 14857,
        request_start_date: filters.startDate,
        request_end_date: filters.endDate,
        // student_id: filters.studentId // Add this if your API supports filtering by student
      };

      const response = await simplePostCall(
        ApiConfig.operatorsaleports,
        JSON.stringify(payload),
      );

      if (response && response.result) {
        setSalesData(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching wallet sales report:", error);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  // 3. Initial Load
  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  // 4. Handlers
  const handleFilterChange = (e) => {
    const { id, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [id === "student_id"
        ? "studentId"
        : id === "startdate"
          ? "startDate"
          : "endDate"]: value,
    }));
  };

  const handleClear = () => {
    setFilters({
      studentId: "",
      startDate: "2024-01-27",
      endDate: "2026-02-02",
    });
  };

  return (
    <div className="wallet-report-container" style={{ paddingTop: "25px" }}>
      <div className="wallet-header-section">
        <div className="wallet-header-box">
          <h3 className="wallet-header-title">Wallet Sales Report</h3>
          <div className="wallet-export-section">
            <button className="wallet-export-button">
              Export <i className="fa fa-angle-down"></i>
            </button>
            {/* ... Export list items ... */}
          </div>
        </div>
      </div>

      <div className="wallet-filter-section">
        <div className="wallet-filter-row">
          <div className="wallet-filter-item">
            <select
              id="student_id"
              className="wallet-select"
              value={filters.studentId}
              onChange={handleFilterChange}
            >
              <option value="">Select Student</option>
              <option value="189">ssds - hjh45</option>
              <option value="207">hebu - 78787878</option>
              <option value="101">Mahesh - 546452367</option>
            </select>
          </div>

          <div className="wallet-filter-item">
            <input
              type="date"
              id="startdate"
              className="wallet-date-input"
              value={filters.startDate}
              onChange={handleFilterChange}
            />
          </div>

          <div className="wallet-filter-item">
            <input
              type="date"
              id="enddate"
              className="wallet-date-input"
              value={filters.endDate}
              onChange={handleFilterChange}
            />
          </div>

          <div className="wallet-filter-item">
            <button
              className="wallet-btn wallet-btn-search"
              onClick={fetchInitialData}
              disabled={loading}
            >
              {loading ? "Searching..." : "Search"}
            </button>
            <button
              className="wallet-btn wallet-btn-clear"
              onClick={handleClear}
            >
              Clear
            </button>
          </div>
        </div>
      </div>

      {/* 5. Table Section */}
      <div
        className="wallet-table-container"
        style={{ marginRight: "15px", marginLeft: "15px" }}
      >
        <table className="payment-mode-table">
          {" "}
          {/* Reusing your table class for consistency */}
          <thead>
            <tr>
              <th>Sr No</th>
              <th>Date</th>
              <th>User Name</th>
              <th>Reference No</th>
              <th>Description</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {salesData.length > 0 ? (
              salesData.map((item, index) => (
                <tr key={item.sale_id}>
                  <td>{index + 1}</td>
                  <td>{item.formatted_date}</td>
                  <td>{`${item.user_name} ${item.user_last_name}`}</td>
                  <td>{item.sale_reference_no || "N/A"}</td>
                  <td>{item.sale_description || "No description"}</td>
                  <td style={{ fontWeight: "bold", color: "#2dce89" }}>
                    {formatNumber(item.sale_amount)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: "center", padding: "7px" }}>
                  <div className="text-center">
                    <ScaleLoader color="#F4BB44" />
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Wallet_Sales_Report_Based;
